import React from 'react';
var SUB_HEADING_STYLES = 'text-subheading font-heading font-semibold uppercase mt-4 mr-0 mb-3 ml-0';
export var SubHeading = function (_a) {
    var children = _a.children;
    return (React.createElement("h2", { className: SUB_HEADING_STYLES }, children));
};
SubHeading.displayName = 'Content.SubHeading';
